'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _reactMeasure = require('react-measure');

var _reactMeasure2 = _interopRequireDefault(_reactMeasure);

var _measurementsConnect = require('./measurementsConnect');

var _measurementsConnect2 = _interopRequireDefault(_measurementsConnect);

var _measurementsRegistry = require('./measurementsRegistry');

var _measurementsRegistry2 = _interopRequireDefault(_measurementsRegistry);

var _measurementsActions = require('./measurementsActions');

var _measurements = require('../../../common/maths/geometry/measurements');

var _point = require('../../../common/maths/geometry/point');

var _propsComparisons = require('../../utils/react/propsComparisons');

var _elementHelper = require('../../../common/elements/elementHelper');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Lib


// Measurements


// Utils


// Prop comparisons
var hasListIndexChanged = (0, _propsComparisons.hasChanged)('listIndex');
var hasParentLocationChanged = (0, _propsComparisons.hasChanged)('parentLocation');

// Always take the centre
var getOriginFromMeasurements = _measurements.getCentrePoint;

var getOriginFromNode = function getOriginFromNode(node) {
    return getOriginFromMeasurements(node.getBoundingClientRect());
};

/**
 * Gets the origin in terms of an offset in px from the top left point of the connection target's measurements.
 * This allows a different origin to be used for irregular shaped elements, while still keeping the connection boundary
 * around the perimeter of the element.  For example, we want to connect to the centre of board icons, but want the
 * connection boundary to include the text.
 *
 * @param measurements {Object} An object with top, left, width and height properties.
 * @param node {HTMLNode} If the node exists it will be used to determine the origin, otherwise the boundary
 *      measurements will be used.
 */
var getOriginOffset = function getOriginOffset(measurements, node) {
    var originPx = node ? getOriginFromNode(node) : getOriginFromMeasurements(measurements);
    var boundaryTopLeftPoint = (0, _measurements.getTopLeftPoint)(measurements);
    return (0, _point.reverseTranslate)(boundaryTopLeftPoint, originPx);
};

var mapStateToProps = function mapStateToProps(state, _ref) {
    var element = _ref.element;

    var parentLocation = null;

    if ((0, _elementHelper.isInList)(element)) {
        var parent = (0, _elementHelper.getParent)(state.get('elements'), element);
        parentLocation = parent && parent.get('location') || null;
    }

    return {
        parentLocation: parentLocation
    };
};

var mapMeasurementsDispatchToProps = function mapMeasurementsDispatchToProps(dispatch) {
    return {
        dispatchMeasurementsSet: function dispatchMeasurementsSet(_ref2) {
            var id = _ref2.id,
                measurements = _ref2.measurements;
            return dispatch((0, _measurementsActions.measurementsSet)({ id: id, measurements: measurements }));
        },
        dispatchMeasurementsRemove: function dispatchMeasurementsRemove(_ref3) {
            var id = _ref3.id;
            return dispatch((0, _measurementsActions.measurementsRemove)({ id: id }));
        }
    };
};

exports.default = function (DecoratedComponent) {
    var _dec, _dec2, _class;

    var MeasureElementDecorator = (_dec = (0, _reactRedux.connect)(mapStateToProps), _dec2 = (0, _measurementsConnect2.default)(undefined, mapMeasurementsDispatchToProps), _dec(_class = _dec2(_class = function (_React$Component) {
        _inherits(MeasureElementDecorator, _React$Component);

        function MeasureElementDecorator(props, context) {
            _classCallCheck(this, MeasureElementDecorator);

            var _this = _possibleConstructorReturn(this, (MeasureElementDecorator.__proto__ || Object.getPrototypeOf(MeasureElementDecorator)).call(this, props, context));

            _this.measureElement = function (measurements) {
                // This is a hack to prevent full-screens from causing the canvas to keep growing.
                // Potentially be more strict here (i.e. only for link element types with a video media type) but
                // for now, keeping it general
                if (measurements.width === screen.width) return;

                var _this$props = _this.props,
                    element = _this$props.element,
                    dispatchMeasurementsSet = _this$props.dispatchMeasurementsSet;

                var id = element.get('id');
                var originOffset = getOriginOffset(measurements, _this.connectionOrigin);

                // Translate measurements based on the canvas scroll
                var canvasScroll = _measurementsRegistry2.default.getCanvasScroll();
                measurements.top += canvasScroll.top;
                measurements.bottom += canvasScroll.top;
                measurements.left += canvasScroll.left;
                measurements.right += canvasScroll.left;

                _this.hasBeenMeasured = true;
                dispatchMeasurementsSet({
                    id: id,
                    measurements: _extends({}, measurements, {
                        originOffset: originOffset
                    })
                });
            };

            _this.connectionOriginRef = function (node) {
                _this.connectionOrigin = node;
            };

            _this.registerConnectionOrigin = function (node) {
                return (
                    // Clones the element so that the consumer doesn't need to be aware that refs are being used
                    _react2.default.cloneElement(node, {
                        ref: _this.connectionOriginRef
                    })
                );
            };

            _this.hasBeenMeasured = false;
            return _this;
        }

        _createClass(MeasureElementDecorator, [{
            key: 'componentWillMount',
            value: function componentWillMount() {
                var element = this.props.element;

                var id = element.get('id');
                _measurementsRegistry2.default.registerElement(id);
            }

            /**
             * Strangely this is needed because the 'top' / 'left' properties aren't causing the ResizeObserver to
             * fire on these elements.  Not really sure if this is expected behaviour or not, but considering the
             * properties can be blacklisted / whitelisted it doesn't seem like it.
             */

        }, {
            key: 'componentDidUpdate',
            value: function componentDidUpdate(prevProps) {
                var element = this.props.element;

                if (element.get('location') !== prevProps.element.get('location') || hasParentLocationChanged(prevProps, this.props) || hasListIndexChanged(prevProps, this.props)) {
                    this.measureComponent.measure();
                }
            }
        }, {
            key: 'componentWillUnmount',
            value: function componentWillUnmount() {
                var _props = this.props,
                    element = _props.element,
                    dispatchMeasurementsRemove = _props.dispatchMeasurementsRemove;

                var id = element.get('id');
                _measurementsRegistry2.default.removeElement(id);

                // Needed to do this because on 'undo' of a target move the element gets mounted again before dismount
                // Thus the dismount was causing the mounted
                if (_measurementsRegistry2.default.getElementReferenceCount(id) < 1 && this.hasBeenMeasured) {
                    dispatchMeasurementsRemove({ id: id });
                }
            }
        }, {
            key: 'render',
            value: function render() {
                var _this2 = this;

                var _props2 = this.props,
                    parentLocation = _props2.parentLocation,
                    rest = _objectWithoutProperties(_props2, ['parentLocation']); // eslint-disable-line no-unused-vars


                var _props3 = this.props,
                    documentMode = _props3.documentMode,
                    readyToMeasure = _props3.readyToMeasure;


                if (documentMode) return _react2.default.createElement(DecoratedComponent, rest);

                return _react2.default.createElement(
                    _reactMeasure2.default,
                    { ref: function ref(c) {
                            _this2.measureComponent = c;
                        },
                        whitelist: ['width', 'height', 'top', 'left'],
                        shouldMeasure: !!readyToMeasure,
                        onMeasure: this.measureElement },
                    _react2.default.createElement(DecoratedComponent, _extends({}, rest, { registerConnectionOrigin: this.registerConnectionOrigin }))
                );
            }
        }]);

        return MeasureElementDecorator;
    }(_react2.default.Component)) || _class) || _class);


    MeasureElementDecorator.propTypes = {
        element: _propTypes2.default.object.isRequired,
        isDragging: _propTypes2.default.bool,
        dispatchMeasurementsSet: _propTypes2.default.func,
        dispatchMeasurementsRemove: _propTypes2.default.func,
        documentMode: _propTypes2.default.bool,
        parentLocation: _propTypes2.default.object,
        readyToMeasure: _propTypes2.default.bool
    };

    return MeasureElementDecorator;
};


//////////////////
// WEBPACK FOOTER
// ./src/client/components/measurements/measureElementDecorator.js
// module id = 1908
// module chunks = 0